var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.37762 7.87352V5.6242C3.37762 2.51804 5.89567 0 9.00183 0C12.108 0 14.626 2.51804 14.626 5.6242V7.87352H15.7507C16.9929 7.87352 18 8.88057 18 10.1228V16.8717C18.0006 18.1129 16.994 19.1204 15.7518 19.121L2.24932 19.121C1.00741 19.121 0.000503196 18.1145 0 16.8726V10.1237C0.000606796 8.88038 1.00815 7.87382 2.25041 7.87443L3.37762 7.87352ZM9.00183 2.24933C7.13642 2.24933 5.6242 3.76155 5.6242 5.62696V7.87627H12.3731V5.62422C12.3716 3.76143 10.8621 2.25142 8.99922 2.24933L9.00183 2.24933Z",
    fill: "#C1C7D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.33feb6aa83203e8e8cf9be0cea213410.svg";
export { ForwardRef as ReactComponent };